import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

export const toolbarStyleSheet = StyleSheet.create({
	toolbar: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[16],
		justifyContent: 'space-between',
	},
	heading: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[4],
	},
	title: {
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.xl,
		fontWeight: fontWeights.bold,
		margin: 0,
	},
	controls: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[12],
	},
	sdr: {
		width: 260,
		[THEME.queries.sm]: {
			width: '100%',
		},
	},
	outcome: {
		width: 200,
		[THEME.queries.sm]: {
			width: '100%',
		},
	},
	// Matches the 38px Cards/Rows TabToggle beside the dropdowns, which only comes in 27px or 38px.
	controlHeight: {
		boxSizing: 'border-box',
		height: 38,
	},
	selectTrigger: {
		backgroundColor: THEME.colors.background.light,
		boxSizing: 'border-box',
		height: 38,
		width: '100%',
	},
});
